import { createSelector } from 'reselect'
import { listFeatureStateSelector } from './listFeatureStateSelector'

export const listSelector = createSelector(listFeatureStateSelector, features => features.pages)
